import * as React from "react";
import { useState } from "react";
import * as H from "history";
import Card from "../core/Card";
import Button from "../core/Button";
import { disableOrg } from "../../libs/organization";
import { toast } from "../../utils";

interface IProps {
  org: IOrganization;
  currentUser?: IUser;
  routerHistory: H.History;
}

const OrgDisable = (props: IProps) => {
  const [submitting, setSubmitting] = useState(false);
  return (
    <Card title="Disable Organization">
      <p>
        Disabling an organization is equivalent to removing an organization.
        Users of that belong to a disabled organization will not be able to
        login
      </p>
      <p>Confirm that you want to disable this organization </p>

      <div style={{ display: "inline", margin: "5px" }}>
        <Button
          color={"primary"}
          loading={submitting}
          disabled={submitting}
          onClick={() => {
            setSubmitting(true);
            disableOrg(props.org.id)
              .then(resp => {
                setSubmitting(false);
                if (resp && resp.status === "ok") {
                  toast.success("Successfully removed organization");
                  Turbolinks.visit("/organizations");
                } else {
                  toast.error("Error removing organization");
                }
              })
              .catch(e => {
                setSubmitting(false);
                toast.error("Error removing organization");
              });
          }}
        >
          Confirm
        </Button>
      </div>

      <div style={{ display: "inline", margin: "5px" }}>
        <Button color={"danger"} onClick={() => props.routerHistory.push("/")}>
          Cancel
        </Button>
      </div>
    </Card>
  );
};

export default OrgDisable;



// WEBPACK FOOTER //
// ./app/javascript/components/org/OrgDisable.tsx